import { useSyncExternalStore } from 'react';
import { RouterProvider } from 'react-router-dom';
import { router } from './router';
import { ShopPopupContainer } from './components/ShopPopupContainer';
import {
  RotateToPortraitOverlay,
  type LandscapeAllowance,
} from './components/RotateToPortraitOverlay';
import { getPlatformCapabilities } from '../platforms/capabilities';
import { hostAllows } from './lib/fullscreen';

const subscribeToRoute = (onChange: () => void) => router.subscribe(onChange);
const currentPath = () => router.state.location.pathname;

function landscapeAllowance(): LandscapeAllowance | undefined {
  const { landscapeGames, landscapeMinHeight, fullscreenButton } = getPlatformCapabilities();
  return landscapeGames && landscapeMinHeight !== undefined
    ? {
        games: landscapeGames,
        minHeight: landscapeMinHeight,
        // The main site is a single host, so its key is '*'.
        fullscreen: hostAllows(fullscreenButton?.hosts, undefined),
      }
    : undefined;
}

export default function App() {
  // The overlay sits beside the router, not inside a route, so it reads the
  // path from the router itself.
  const pathname = useSyncExternalStore(subscribeToRoute, currentPath);
  return (
    <>
      <RouterProvider router={router} />
      {/* Module 28 — mounted beside the router (not inside any route) so the
          shared Shop popup overlays whatever is active: a Lobby screen or a
          running game. Opened via useShopPopupStore. */}
      <ShopPopupContainer />
      {/* Module 32 (WP-UI.6) — mobile-web portrait enforcement: covers the whole
          app when a phone browser is turned to landscape (native builds are
          OS-locked; desktop never triggers it). A game with its own landscape
          layout (`landscapeGames`) is walled off only below its floor. */}
      <RotateToPortraitOverlay pathname={pathname} landscape={landscapeAllowance()} />
    </>
  );
}
